import { TimeTracking } from 'src/tabs/models/TimesheetsInterface';

export interface DaysForecastedHours {
  dayOfweek?: number;
  dayOfWeekType?: number;
  totalWeekHours?: number;
  totalWeekType?: number;
}

export const getForecastHours = (data: TimeTracking[]) => {
  const daysForecastedHours: DaysForecastedHours[] = [];
  let weeklyForecastedHours = 0;

  for (let day = 0; day <= 6; day++) {
    let dayForcastedHours = 0;
    for (let assignment = 0; assignment < data.length; assignment++) {
      dayForcastedHours +=
        data[assignment].dayEntries[day].new_forecastedsupplyallocation || 0;
    }

    const isWorkDay = data.some(
      (ass) => ass.dayEntries[day].new_daytype === 100000000
    );
    daysForecastedHours[day] = {
      dayOfweek: dayForcastedHours,
      dayOfWeekType: isWorkDay ? 100000000 : 100000001,
    };
  }

  daysForecastedHours.forEach(
    (day) => (weeklyForecastedHours += day.dayOfweek)
  );

  daysForecastedHours[7] = {
    totalWeekHours: weeklyForecastedHours,
    totalWeekType: weeklyForecastedHours > 0 ? 100000000 : 100000001,
  };

  return daysForecastedHours;
};
